<template>
  <el-dialog class="pc-dialog pc-dialog__add-notebook-catalog"
    :title="title"
    :visible.sync="visible"
    width="40rem"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeHandler"
    @open="openHandler"
    >
    <div class="path" v-if="path.length > 0">{{path.join(' / ')}} </div>
    <div class="name">
      <el-input :class="{'pc-is-error':invalid}" v-model="name" :placeholder="placeholder" size="small" @input="validateHandler"
        @keyup.native.enter="okHandler"/>
    </div>
    <span slot="footer" class="dialog-footer">
      <span class="pc-color-error" v-show="invalid">{{errorMessage}}</span>
      <el-button type="primary" size="small" @click="okHandler" :disabled="waiting">{{okButtonText}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { isNullOrWhiteSpace } from '@/common/utils'
import _ from 'lodash'
import { operateError } from '@/common/errors'

export default {
  name: 'RenameDialog',
  data () {
    return {
      name: '',
      invalid: false,
      waiting: false,
      path: []
    }
  },
  computed: {
    ...mapGetters('dialog', {
      renameDailogValue: 'rename'
    }),
    ...mapGetters('workbench/current', {
      notebook: 'notebook',
      note: 'note',
      catalogPaths: 'catalogPaths'
    }),
    visible: {
      get () {
        return this.renameDailogValue.visible
      },
      set (visible) {
        this.setRenameDailogValue({
          visible,
          data: {
            type: ''
          }
        })
      }
    },
    title () {
      if (this.renameDailogValue.data.type === 'NOTEBOOK') {
        return '笔记本重命名'
      }
      if (this.renameDailogValue.data.type === 'NOTEBOOK_CATALOG') {
        return '目录重命名'
      }
      return '笔记重命名'
    },
    placeholder () {
      if (this.renameDailogValue.data.type === 'NOTEBOOK') {
        return '请输入笔记本名称'
      }
      if (this.renameDailogValue.data.type === 'NOTEBOOK_CATALOG') {
        return '请输入目录名称'
      }
      return '请输入笔记名称'
    },
    okButtonText () {
      let text = '重命名'
      if (this.waiting) {
        text += ' ...'
      }
      return text
    },
    errorMessage () {
      if (this.renameDailogValue.data.type === 'NOTEBOOK') {
        return '笔记本名称不能为空'
      }
      if (this.renameDailogValue.data.type === 'NOTEBOOK_CATALOG') {
        return '目录名称不能为空'
      }
      return '笔记名称不能为空'
    }
  },
  methods: {
    ...mapMutations('dialog', {
      setRenameDailogValue: 'SET_RENAME'
    }),
    ...mapActions('workbench/current', {
      renameNotebook: 'renameNotebook',
      renameNotebookCatalog: 'renameNotebookCatalog',
      renameNotebookNote: 'renameNotebookNote',
      renameNote: 'renameNote'
    }),
    openHandler () {
      if (this.renameDailogValue.data.type === 'NOTEBOOK') {
        this.name = this.notebook.name
        this.path = [this.notebook.name]
        return
      }
      if (this.renameDailogValue.data.type === 'NOTE') {
        this.name = this.note.name
        this.path = [this.note.name]
        return
      }
      if (this.renameDailogValue.data.type === 'NOTEBOOK_CATALOG') {
        const catalog = _.find(this.notebook.catalogs, n => n.id === this.renameDailogValue.data.id)
        const parentCatalogId = catalog.parentCatalogId
        const path = this.catalogPaths(parentCatalogId)
        path.push(catalog.name)
        this.path = path
        this.name = catalog.name
        return
      }
      if (this.renameDailogValue.data.type === 'NOTEBOOK_NOTE') {
        const note = _.find(this.notebook.notes, n => n.id === this.renameDailogValue.data.id)
        const catalogId = note.catalogId
        const path = this.catalogPaths(catalogId)
        path.push(note.name)
        this.path = path
        this.name = note.name
        return
      }
      this.path = []
      this.name = ''
    },
    closeHandler () {
      this.name = ''
      this.invalid = false
      this.waiting = false
    },
    validateHandler () {
      if (isNullOrWhiteSpace(this.name)) {
        this.invalid = true
      } else {
        this.invalid = false
      }
    },
    async okHandler () {
      this.validateHandler()
      if (this.invalid) {
        return
      }
      try {
        this.waiting = true
        if (this.renameDailogValue.data.type === 'NOTEBOOK') {
          await this.renameNotebook(this.name)
        } else if (this.renameDailogValue.data.type === 'NOTEBOOK_CATALOG') {
          await this.renameNotebookCatalog({
            catalogId: this.renameDailogValue.data.id,
            name: this.name
          })
        } else if (this.renameDailogValue.data.type === 'NOTEBOOK_NOTE') {
          await this.renameNotebookNote({
            noteId: this.renameDailogValue.data.id,
            name: this.name
          })
        } else if (this.renameDailogValue.data.type === 'NOTE') {
          await this.renameNote(this.name)
        }
        this.setRenameDailogValue({
          visible: false,
          data: {
            type: ''
          }
        })
      } catch (e) {
        console.dir(e)
        operateError(e, '重命名')
      } finally {
        this.waiting = false
      }
    }
  }
}
</script>

<style lang="scss">
.pc-dialog__rename {
}
</style>
